<template>
  <div>
    <ts-page-title
      :title="$t('evaluationExamination.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('evaluationExamination.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center tw-space-x-3">
          <a-button
            type="primary"
            @click="$router.push({ name: 'evaluation-examination-create' })"
          >
            {{ $t("addNew") }}
          </a-button>
          <!-- <a-range-picker
            v-model="dateRange"
            :allowClear="false"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            style="width: 200px"
            @change="fetchData()"
          /> -->
        </div>
        <div class="tw-justify-end tw-space-x-2">
          <a-input
            v-model="search"
            v-tooltip="$t('evaluationExamination.search')"
            :placeholder="$t('evaluationExamination.search')"
            style="width: 250px"
            class="inline-block"
          />
          <a-button v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </a-button>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'examination_event',
          }"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <!-- <td class="tw-whitespace-nowrap">
            {{ record.candidates.card_number }}
          </td> -->
            <td>
              <img
                class="tw-rounded tw-h-8 tw-w-7"
                v-lazy="{
                  src: photo(record),
                  error:
                    record.sex == 'Male'
                      ? require('@/assets/staff-default-man.png')
                      : require('@/assets/staff-default-women.png'),
                  loading: require('@/assets/Rolling-1s-200px.svg'),
                  preLoad: 1.3,
                  attempt: 1,
                }"
              />
            </td>
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.branch.prefix_code }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.candidates.full_name_en }}
            </td>
            <td class="tw-whitespace-nowrap tw-text-center">
              {{ record.candidates.sex }}
            </td>
            <td class="tw-whitespace-nowrap">{{ record.candidates.phone }}</td>
            <td class="tw-whitespace-nowrap">
              {{ record.cert_type_name }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.issue_date }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.expire_date }}
            </td>
            <td class="tw-text-center tw-whitespace-nowrap">
              {{
                record.evaluation_examinations[0]
                  ? record.evaluation_examinations[0].created_at
                  : ""
              }}
            </td>
            <td class="tw-text-center tw-whitespace-nowrap">
              {{
                record.evaluation_examinations[0]
                  ? record.evaluation_examinations[0].created_by
                  : ""
              }}
            </td>
          </template>

          <div slot="expand" slot-scope="prop">
            <table class="tw-w-11/12 tw-mx-auto detail">
              <thead>
                <tr class="tw-uppercase tw-bg-gray-200 tw-h-8 tw-text-white">
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("evaluationExamination.subjectCode") }}
                  </th>
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("evaluationExamination.subject") }}
                  </th>
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("evaluationExamination.subjectType") }}
                  </th>
                  <th class="tw-pl-2 tw-text-center tw-whitespace-nowrap">
                    {{ $t("evaluationExamination.isPass") }}
                  </th>
                  <th class="tw-pl-2 tw-text-center tw-whitespace-nowrap">
                    {{ $t("evaluationExamination.isSubjectDisplay") }}
                  </th>
                  <th class="tw-pl-2">
                    {{ $t("evaluationExamination.remark") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="tw-border-b-2"
                  v-for="(detail, index) in prop.record.evaluation_examinations"
                  :key="index"
                >
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.subject_code }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.subject_name_en }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.subject_type_id == 1 ? "Basic" : "Core" }}
                  </td>
                  <td
                    class="tw-text-center tw-items-center tw-whitespace-nowrap"
                  >
                    <a-switch
                      :loading="waiting"
                      v-model="detail.is_passed"
                      size="small"
                      @change="onUpdate(detail)"
                    />
                  </td>
                  <td
                    class="tw-text-center tw-items-center tw-whitespace-nowrap"
                  >
                    <a-switch
                      :disabled="!detail.is_passed"
                      :loading="waiting"
                      v-model="detail.is_subject_display"
                      size="small"
                      @change="onDisplayUpdate(detail)"
                    />
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.remarks }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-drawer
      :title="$t('filter')"
      :closable="false"
      :visible="visible"
      :zIndex="1020"
      @close="() => (visible = false)"
      width="300px"
    >
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t("testingCenter")
        }}</label>
        <ts-branch-filter @filter="(value) => (branch_id = value)" />
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
import { Errors } from "form-backend-validation";
export default {
  name: "evaluationExaminationIndex",
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      showForm: false,
      visible: false,
      branch_id: [],
    };
  },
  computed: {
    ...mapState("academic/evaluationExamination", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.academic.evaluationExamination.search;
      },
      set(newValue) {
        this.$store.commit(
          "academic/evaluationExamination/SET_SEARCH",
          newValue
        );
        this.$store.commit("academic/evaluationExamination/RESET_CURRENT_PAGE");
      },
    },
    dateRange: {
      get() {
        return this.$store.state.academic.evaluationExamination.dateRange;
      },
      set(newValue) {
        this.$store.commit(
          "academic/evaluationExamination/SET_DATE_RANGE",
          newValue
        );
      },
    },
    columns() {
      return [
        // {
        //   name: this.$t("evaluationExamination.cardNumber"),
        //   style: "width: 200px;white-space: nowrap;",
        // },
        {
          name: this.$t("evaluationExamination.photo"),
          style: "width: 50px;text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("evaluationExamination.testingCenter"),
          style: "text-align:center;width:150px;white-space: nowrap;",
        },
        {
          name: this.$t("evaluationExamination.nameEn"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("evaluationExamination.sex"),
          style: "white-space: nowrap;width: 150px;text-align:center;",
        },
        {
          name: this.$t("evaluationExamination.phone"),
          style: "white-space: nowrap;width: 250px",
        },
        {
          name: this.$t("evaluationExamination.certTypeName"),
          style: "white-space: nowrap;width: 250px",
        },
        {
          name: this.$t("evaluationExamination.issueDateIndex"),
          style: "white-space: nowrap;width: 250px",
        },
        {
          name: this.$t("evaluationExamination.expireDate"),
          style: "white-space: nowrap;width: 250px",
        },
        {
          name: this.$t("evaluationExamination.evaluationAt"),
          style: "text-align:center;white-space: nowrap;width: 150px",
        },
        {
          name: this.$t("evaluationExamination.evaluationBy"),
          style: "text-align:center;white-space: nowrap;width: 150px",
        },
      ];
    },
  },
  methods: {
    photo(record) {
      if (record.photo) {
        return record.photo;
      }

      return record.sex == "Male"
        ? require("@/assets/staff-default-man.png")
        : require("@/assets/staff-default-women.png");
    },
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/evaluationExamination/fetch", {
          ...attributes,
          branch_id: this.branch_id,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    async onUpdate(record) {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/evaluationExamination/update", record)
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.fetchData();
          this.waiting = false;
        });
    },
    async onDisplayUpdate(record) {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/evaluationExamination/displayUpdate", record)
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.fetchData();
          this.waiting = false;
        });
    },
    clearEdit() {
      this.$store.commit("academic/evaluationExamination/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value });
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/evaluationExamination/RESET_STATE");
    next();
  },
};
</script>

<style lang="scss" scoped>
</style>